<section>
  <h1 mat-dialog-title class="text-center">{{ sponsor.name }}</h1>
  <div mat-dialog-content style="padding: 0px">
    <img src="{{ sponsor.ad.url }}" alt="" width="100%" height="auto">
  </div>
  <div mat-dialog-actions align="end">
    <button mat-stroked-button color="accent" mat-dialog-close>Cerrar</button>
  </div>
</section>